import { AccountMovementsViewModel } from "../../accounting/models/accounting-movement.model";

export class FinanciacionPropiaModel {

  uid: string;
  accountingModelsCortoPlazoNumber: string;
  accountingModelsLargoPlazoNumber: string;
  descripcion: string;
  filesFinanciacionPropiaUid: string;
  importeInicial: number;
  importePendiente: number;
  comisionApertura: number;
  fechaConstitucion: Date;
  plazo: number;
  fechaFinalizacion: Date;
  tipoInteres: number;
  carencia: number;
  tipoLiquidaciones: number;
  bankAccountsUid: string;
  duracion: number;
  cuentaContableACrear: string;
  partnersId: number;
  partnersName: string;
  //Importación cuentas contables
  manualMovement: AccountMovementsViewModel;

  constructor() { }

  // Enums - No eliminar
  /* Mensual = 1,
  Bimensual = 2,
  Trimestral = 3,
  Semestral = 4,
  Anual = 5 */

}

export class ConstitucionFinanciacionPropiaModel {

  uid: string;
  financiacionPropiaId: string;
  plazo: number;
  fecha: Date;
  concepto: string;
  importe: number;
  comisionApertura: number;
  gastosBancarios: number;
  bankAccountsUid: string;
  bankAccountInfo: string;

  activitiesUid: string;
  activitiesName: string;

  constructor() {
    this.plazo = 0;
    this.comisionApertura = 0;
    this.gastosBancarios = 0;
  }

  // Enums - No eliminar
  /* Corto_Plazo = 1,
  Largo_Plazo = 2, */

}

export class DeudaACortoPlazoFinanciacionPropiaModel {

  uid: string;
  financiacionPropiaId: string;
  fecha: Date;
  concepto: string;
  importe: number;

  activitiesUid: string;
  activitiesName: string;

  constructor() { }

}

export class PagoCuotasFinanciacionPropiaModel {

  uid: string;
  financiacionPropiaId: string;
  fecha: Date;
  concepto: string;
  importeCapital: number;
  intereses: number;
  gastosBancarios: number;
  taxesId: number;
  bankAccountsUid: string;
  bankAccountInfo: string;

  activitiesUid: string;
  activitiesName: string;

  constructor() {
    this.intereses = 0;
    this.gastosBancarios = 0;
  }

}

